import axiosInstance from '../services/axiosInstance';
import { envUrls } from './env';

// Uncomment this to test localhost
// envUrls.fundingService = 'http://localhost:7070/funding/';

export default class FundingService {
  async getTableData(payload) {
    return await axiosInstance
      .post(`${envUrls.fundingService}table-data`, payload, {
        headers: {
          appName: 'bluescout',
        },
      })
      .then((response) => response.data)
      .catch((err) => console.log('Error', '=>', err));
  }

  async getChoroplethData(payload) {
    return await axiosInstance
      .post(`${envUrls.fundingService}charts/choropleth`, payload, {
        headers: {
          appName: 'bluescout',
        },
      })
      .then((response) => response.data)
      .catch((err) => console.log('Error', '=>', err));
  }

  async getFundingByType(payload) {
    return await axiosInstance
      .post(`${envUrls.fundingService}charts/funding-by-type`, payload, {
        headers: {
          appName: 'bluescout',
        },
      })
      .then((response) => response.data)
      .catch((err) => console.log('Error', '=>', err));
  }

  async getFundingByTypeOverTime(payload) {
    return await axiosInstance
      .post(
        `${envUrls.fundingService}charts/funding-by-type-over-time`,
        payload,
        {
          headers: {
            appName: 'bluescout',
          },
        }
      )
      .then((response) => response.data)
      .catch((err) => console.log('Error', '=>', err));
  }

  async getPscCodeData(payload) {
    return await axiosInstance
      .post(`${envUrls.fundingService}charts/psc-codes`, payload, {
        headers: {
          appName: 'bluescout',
        },
      })
      .then((response) => response.data)
      .catch((err) => console.log('Error', '=>', err));
  }

  async getFundingCounts(payload) {
    return await axiosInstance
      .post(`${envUrls.fundingService}counts`, payload, {
        headers: {
          appName: 'bluescout',
        },
      })
      .then((response) => response.data)
      .catch((err) => console.log('Error', '=>', err));
  }
}
